<!-- ================管理端-一级代理====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">一级代理列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleCreateSupplier">添加一级代理</div>
        </div>
        <div class="admin-search-container">
            <div class="admin-search-name">代理区域:</div>
            <div class="admin-search-item" >
                <el-select class="admin-select1" clearable @change="changeProvince" v-model="provinceNo" placeholder="请选择">
                    <el-option v-for="item in regionList"
                               :key="item.regionNo"
                               :label="item.regionShortName"
                               :value="item.regionNo" />
                </el-select>
            </div>
            <div class="admin-search-item" >
                <el-select class="admin-select1" clearable @change="changeCity" v-model="cityNo" placeholder="请选择">
                    <el-option v-for="item in cityList"
                               :key="item.regionNo"
                               :label="item.regionShortName"
                               :value="item.regionNo" />
                </el-select>
            </div>
            <div class="admin-search-item" >
                <el-select class="admin-select1" clearable @change="changeCountry" v-model="countyNo" placeholder="请选择">
                    <el-option v-for="item in countyList"
                               :key="item.regionNo"
                               :label="item.regionShortName"
                               :value="item.regionNo" />
                </el-select>
            </div>
            <div class="admin-search-item right-start" >
                <el-input class="admin-input1" v-model="queryParams.supplierName" placeholder="请输入代理名称" >
                    <template #append>
                        <el-button @click="handleQuery"  class="name-search-btn" type="primary"
                                   icon="el-icon-search"/>
                    </template>
                </el-input>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 255px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                <el-table-column width="240"  label="一级代理" prop="supplierName" align="center" >
                    <template #default="scope">
                        <div :title="scope.row.supplierName" style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.supplierName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="140" label="代理账号" align="center" prop="supplierUsername" />
                <el-table-column width="100" label="管理员姓名" align="center" prop="trueName" />
                <el-table-column width="100" align="center" label="状态" prop="supplierStatus">
                    <template #default="scope">
                        <el-tag type="success" v-if="scope.row.supplierStatus === 1">启用</el-tag>
                        <el-tag type="danger" v-if="scope.row.supplierStatus === 2">停用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="服务时限" width="280" prop="">
                    <template #default="scope">
                        <div>
                            {{ timestampToTime(scope.row.beginTime) }}至{{ timestampToTime(scope.row.endTime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="80" label="总卡数" align="center" prop="cardNum" />
                <el-table-column width="80" label="分配卡数" align="center" prop="cardUsedNum" />
                <el-table-column width="80" label="库存卡数" align="center" prop="stockNum" >
                    <template #default="scope">
                        <div>{{scope.row.cardNum-scope.row.cardUsedNum}}</div>
                    </template>
                </el-table-column>
                <el-table-column width="80" label="激活卡数" align="center" prop="cardActiveNum" >
                    <template #default="scope">
                        <div>{{scope.row.cardActiveNum}}</div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center" width="240">
                    <template #default="scope">
                        <el-button  type="primary" size="small" @click="handleUpdateSupplier(scope.row)">编辑</el-button>
                        <el-button  type="primary" size="small" @click="handleCardManager(scope.row)">卡管理</el-button>
                        <el-button  type="success" v-if="scope.row.supplierStatus===2" size="small"  @click="handleStopOrStart(scope.row)">启用</el-button>
                        <el-button  type="danger" v-if="scope.row.supplierStatus===1" size="small" @click="handleStopOrStart(scope.row)">停用</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false" :pageSizes="[10, 20, 30]" :total="total"
                        v-model:page.sync="queryParams.pageNum" 
                        v-model:limit.sync="queryParams.pageSize" 
                        @pagination="pageList" />
        </div>
    </div>

    <!--创建一级代理商-->
    <el-dialog title="创建一级代理" v-model="isShowCreateSupplier" width="660px">
        <el-form ref="supplierForm" :model="supplierForm"
                 :rules="supplierFormRules" label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="管理员账号" prop="supplierUsername">
                        <el-input v-model="supplierForm.supplierUsername" placeholder="请输入管理员账号" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="管理员姓名" prop="trueName">
                        <el-input v-model="supplierForm.trueName" placeholder="请输入管理员姓名" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="代理名称" prop="supplierName">
                        <el-input v-model="supplierForm.supplierName" placeholder="请输入代理名称" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="代理区域" prop="regionInfo">
                        <el-cascader style="width: 100%" :options="regionList"
                                     v-model="supplierForm.regionInfo"
                                     :props="props" clearable filterable placeholder="请选择区域，可关键字搜索" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form-item label="服务日期" prop="supplierTime">
                    <el-col :span="11" class="date_picker">
                        <el-date-picker style="width: 100%;"
                                        @change="startDateConfirm"
                                        :disabled-date="disabledDate"
                                        v-model="supplierForm.beginTime" type="date" placeholder="开始日期" value-format="x" />
                    </el-col>
                    <el-col :span="2" class="text-center">
                        <span class="text-gray-500">至</span>
                    </el-col>
                    <el-col :span="11">
                        <el-date-picker class="date_picker" @change="endDateConfirm"
                                        :disabled-date="endDisabledDate"
                                        style="width: 100%;" v-model="supplierForm.endTime"
                                        type="date" placeholder="结束日期" value-format="x" />
                    </el-col>
                </el-form-item>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dis-flex-row-center">
                <el-button type="primary" @click="submitCreateSupplier">确 定</el-button>
                <el-button @click="isShowCreateSupplier = false">取 消</el-button>
            </div>
        </template>
    </el-dialog>

    <!--编辑一级代理商-->
    <el-dialog title="编辑一级代理" v-model="isShowUpdateSupplier" width="60%">
        <el-form ref="supplierUpdateForm" :model="updateSupplierForm"
                 :rules="updateSupplierFormRules" label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="管理员账号" prop="supplierUsername">
                        <el-input disabled v-model="updateSupplierForm.supplierUsername" placeholder="请输入管理员账号" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="管理员姓名" prop="trueName">
                        <el-input v-model="updateSupplierForm.trueName" placeholder="请输入管理员姓名" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="代理名称" prop="supplierName">
                        <el-input v-model="updateSupplierForm.supplierName" placeholder="请输入代理名称" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="代理区域" prop="regionInfo">
                        <el-cascader style="width: 100%" :options="regionList"
                                     v-model="updateSupplierForm.regionInfo"
                                     :props="props" clearable filterable placeholder="请选择区域，可关键字搜索" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form-item label="服务日期" prop="supplierTime">
                    <el-col :span="11" class="date_picker">
                        <el-date-picker style="width: 100%;"
                                        @change="startDateConfirm"
                                        :disabled-date="disabledDate"
                                        v-model="updateSupplierForm.beginTime" type="date" placeholder="开始日期" value-format="x" />
                    </el-col>
                    <el-col :span="2" class="text-center">
                        <span class="text-gray-500">至</span>
                    </el-col>
                    <el-col :span="11">
                        <el-date-picker class="date_picker" @change="endDateConfirm"
                                        :disabled-date="endDisabledDate"
                                        style="width: 100%;" v-model="updateSupplierForm.endTime"
                                        type="date" placeholder="结束日期" value-format="x" />
                    </el-col>
                </el-form-item>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dis-flex-row-center">
                <el-button type="primary" @click="submitUpdateSupplier">确 定</el-button>
                <el-button @click="isShowUpdateSupplier = false">取 消</el-button>
            </div>
        </template>
    </el-dialog>

    <!--卡管理-->
    <el-dialog title="卡管理" v-model="isShowSupplierCard" width="600px">
        <el-row style="text-align: left;width: 100%" class="mb10">
            <el-col :span="14" class="first-item">
                <el-radio-group @change="changeActiveType" v-model="activeType">
                    <el-radio-button label="添加卡" />
                    <el-radio-button label="库存卡查询" />
                </el-radio-group>
            </el-col>
            <el-col :span="10">
            </el-col>
        </el-row>
        <div v-if="activeType==='添加卡'">
            <el-form ref="supplierCardForm" :model="supplierCardForm"
                     :rules="supplierCardFormRules" label-width="100px">
                <el-divider>代理信息</el-divider>
                <el-row>
                    <el-col :span="14">
                        <el-form-item label="管理员账号" prop="supplierUsername">
                            <el-input disabled v-model="supplierCardForm.supplierUsername" placeholder="请输入管理员账号" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="14">
                        <el-form-item label="代理名称" prop="supplierName">
                            <el-input disabled v-model="supplierCardForm.supplierName" placeholder="请输入代理名称" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider>本次授权卡信息</el-divider>
                <el-row>
                    <el-form-item label="卡类型" prop="cardType">
                        <el-select style="width: 140px;" @change="fillerCard" v-model="supplierCardForm.cardType" placeholder="请选择卡类型">
                            <el-option v-for="item in cardTypeList" :key="item.value" :label="item.name"
                                       :value="item.value" />
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item class="pull-right" label="卡年限" prop="cardYear">
                        <el-input-number @change="fillerCard" v-model="supplierCardForm.cardYear" step-strictly step="1"
                                         :min="1" :max="10" />
                    </el-form-item>
                </el-row>
                <el-row v-if="selCardNum&&selCardNum>0">
                    <el-col :span="12">
                        <el-form-item label="授权卡数" prop="cardCount">
                            <el-input-number v-model="supplierCardForm.cardCount" step-strictly step="1"
                                             :min="0" :max="this.selCardNum" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <div style="font-size: 14px;align-items: center;height: 100%">最大可授权数量:<span style="color: red;">{{this.selCardNum}}</span></div>
                    </el-col>
                </el-row>
            </el-form>

            <div class="dis-flex-row-center">
                <el-button type="primary" @click="SubSupplierAddCard">确 定</el-button>
                <el-button @click="isShowSupplierCard = false">取 消</el-button>
            </div>
        </div>
        <div v-if="activeType==='库存卡查询'">
            <div>
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 300px)"
                          :data="supStockCardList"
                          class="custom-table"
                          highlight-current-row>
                    <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                    <el-table-column label="卡编号" prop="supplierName" align="center" >
                        <template #default="scope">
                            <div :title="scope.row.cardNo" style="color: #377f7f;" class="text-one cursor">
                                {{ scope.row.cardNo }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column  label="卡年限" width="80"  align="center" prop="cardYear">
                        <template #default="scope">
                            <div :title="scope.row.cardYear" class="text-one cursor">
                                {{ scope.row.cardYear }}年
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="卡版本" prop="cardType">
                        <template #default="scope">
                            <div type="success" v-if="scope.row.cardType == 1">幼儿园版</div>
                            <div type="success" v-if="scope.row.cardType == 2">基础版</div>
                            <div type="success" v-if="scope.row.cardType == 3">专业版</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import {createLevelOneSupplier,pageSupplier,updateSupplier,stopOrStartSupplier} from "@/api/admin/supplier";
import {listStockCard,supplierAddCard} from "@/api/admin/card";
import {regionTree} from "@/api/admin/region"
import {timestampDate, timestampToTime} from "@/utils/date";

export default {
    components: {},
    name: "supplierOneIndex",
    data() {
        return {
            timestampToTime,
            timestampDate,
            loading: false,
            isShowCreateSupplier:false,
            isShowUpdateSupplier:false,
            isShowSupplierCard:false,
            activeType:'添加卡',
            /*省市区县数据*/
            provinceNo:'', // 省
            cityNo:'',  // 市
            countyNo:'', // 区县
            regionList:[],
            cityList:[],
            countyList:[],
            /*分页查询一级代理商*/
            queryParams:{
                parentId:'0',
                supplierName:'',
                supplierStatus:'',
                regionInfo:'',
                supplierLevel:1,
                pageNum: 1,
                pageSize: 10,
            },
            dataList:[],
            total:0,
            /*新增一级代理商*/
            supplierForm:{
                supplierId:"",
                supplierUsername:"",
                trueName:"",
                supplierName:'',
                beginTime:'',
                endTime:'',
                regionInfo:[],
            },
            supplierFormRules:{
                supplierUsername: [{ required: true, message: "请输入管理员账号", trigger: "blur" },],
                trueName: [{ required: true, message: "请输入管理员姓名", trigger: "blur" },],
                supplierName: [{ required: true, message: "请输入代理名称", trigger: "blur" },],
                supplierTime: [{ required: true, validator: this.checkTimeValidator }],
            },
            props:{
                multiple: true,
                checkStrictly: true,
                label:'regionShortName',
                value:'regionNo',
                children:'children'
            },
            /*编辑一级代理*/
            updateSupplierForm:{
                supplierId:"",
                supplierUsername:"",
                trueName:"",
                supplierName:'',
                beginTime:'',
                endTime:'',
                regionInfo:[],
            },
            updateSupplierFormRules:{
                supplierUsername: [{ required: true, message: "请输入管理员账号", trigger: "blur" },],
                trueName: [{ required: true, message: "请输入管理员姓名", trigger: "blur" },],
                supplierName: [{ required: true, message: "请输入代理名称", trigger: "blur" },],
                supplierTime: [{ required: true, validator: this.checkUpdateTimeValidator }],
            },
            /*卡管理-新增卡*/
            supplierCardForm:{
                supplierId:"",
                supplierName:'',
                supplierUsername:"",
                cardCount:0,
                cardType:'',
                cardYear:'',
            },
            supplierCardFormRules:{
                supplierUsername: [{ required: true, message: "请输入代理账号", trigger: "blur" },],
                supplierName: [{ required: true, message: "请输入代理名称", trigger: "blur" },],
                cardCount: [{ required: true, message: "请输入数量", trigger: "blur" },],
                cardType: [{ required: true, message: "请选择卡类型", trigger: "change" },],
                cardYear: [{ required: true, message: "请输入卡年限", trigger: "blur" },],
            },
            // 系统卡库存卡
            stockCardList:[],
            stockCardNum:0,
            // 代理卡库存
            supStockCardList:[],
            supStockCardNum:0,
            // 可选卡
            selCardList:[],
            selCardNum:0,
            cardTypeList: [
                { name: 'B卡', value: 1 },
                { name: 'C卡', value: 2 },
                { name: '课程卡', value: 3 },
            ],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryRegionTree();
        this.pageList();
        this.queryStockCard();
    },
    mounted() {},
    methods: {
        /*===========数据查询============*/
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageSupplier(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        queryRegionTree(){
            regionTree().then(res => {
                if (res.data.code === 1) {
                    this.regionList = res.data.data;
                }else {
                    this.$message.error("请求失败")
                }
            })
        },
        changeProvince(){
            this.queryParams.regionInfo = this.provinceNo;
            this.cityNo = '';
            this.countyNo = '';
            this.cityList = [];
            this.countyList = [];
            this.regionList.forEach(r => {
                if (this.provinceNo === r.regionNo) {
                    this.cityList = r.children;
                }
            })
            this.handleQuery();
        },
        changeCity(){
            this.queryParams.regionInfo = this.cityNo;
            if (!this.cityNo){
                this.queryParams.regionInfo = this.provinceNo;
            }
            this.countyNo = '';
            this.countyList = [];
            this.cityList.forEach(c => {
                if (this.cityNo === c.regionNo) {
                    this.countyList = c.children;
                }
            })
            this.handleQuery();
        },
        changeCountry(){
            this.queryParams.regionInfo = this.countyNo;
            if (!this.countyNo){
                this.queryParams.regionInfo = this.cityNo;
            }
            this.handleQuery();
        },
        /*===========代理商============*/
        handleCreateSupplier(){
            this.supplierForm.supplierId = '';
            this.supplierForm.supplierName = '';
            this.supplierForm.trueName = '';
            this.supplierForm.supplierUsername = '';
            this.supplierForm.beginTime = '';
            this.supplierForm.endTime = '';
            this.supplierForm.regionInfo = [];
            this.isShowCreateSupplier = true;
        },
        submitCreateSupplier(){
            this.$refs["supplierForm"].validate(valid => {
                if (valid) {
                    createLevelOneSupplier(this.supplierForm).then(res => {
                        if (res.data.code === 1) {
                            this.pageList();
                            this.isShowCreateSupplier = false;
                        }else {
                            this.$message.error(res.data.msg)
                            this.isShowCreateSupplier = false;
                        }
                    })
                }
            })
        },
        handleUpdateSupplier(item){
            let sr = item.supplierRegion;
            this.updateSupplierForm = item;
            this.updateSupplierForm.regionInfo = [];
            if (sr){
                this.updateSupplierForm.regionInfo = JSON.parse(sr);
            }
            this.isShowUpdateSupplier  = true;
        },
        submitUpdateSupplier(){
            this.$refs["supplierUpdateForm"].validate(valid => {
                if (valid) {
                    updateSupplier(this.updateSupplierForm).then(res => {
                        if (res.data.code === 1) {
                            this.pageList();
                            this.isShowUpdateSupplier = false;
                        }else {
                            this.$message.error("请求失败")
                            this.isShowUpdateSupplier = false;
                        }
                    })
                }
            })
        },
        handleStopOrStart(item){
            stopOrStartSupplier({ supplierId: item.supplierId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功")
                    this.pageList();
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        /*===========卡管理============*/
        queryStockCard(){
            listStockCard().then(res => {
                if (res.data.code === 1) {
                    this.stockCardList = res.data.data;
                    if (this.stockCardList){
                        this.stockCardNum = this.stockCardList.length;
                    }
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleCardManager(item){
            this.supplierCardForm.supplierId = item.supplierId;
            this.supplierCardForm.supplierName = item.supplierName;
            this.supplierCardForm.supplierUsername = item.supplierUsername;
            this.supStockCardList = item.cardList;
            this.selCardList = [];
            this.selCardNum = 0;
            this.supplierCardForm.cardType =  ''
            this.supplierCardForm.cardCount = 0;
            this.isShowSupplierCard = true;
        },
        changeActiveType(){},
        fillerCard(){
            if (this.supplierCardForm.cardType&&this.supplierCardForm.cardYear){
                this.selCardList = this.stockCardList.filter(item => {
                    return item.cardType ==this.supplierCardForm.cardType&&item.cardYear==this.supplierCardForm.cardYear;
                })
                this.selCardNum = this.selCardList.length;
            }
        },
        SubSupplierAddCard(){
            if (this.selCardList.length===0){
                this.$message.error("当前类型或年限暂无可授权卡")
                return;
            }
            if (this.supplierCardForm.cardCount===0){
                this.$message.error("请增加授权卡数")
                return;
            }
            this.$refs["supplierCardForm"].validate(valid => {
                if (valid) {
                    supplierAddCard(this.supplierCardForm).then(res => {
                        if (res.data.code === 1) {
                            this.$message.success("操作成功")
                            this.pageList();
                            this.queryStockCard();
                            this.isShowSupplierCard = false;
                        }else {
                            this.$message.error("操作失败")
                            this.isShowSupplierCard = false;
                        }
                    })
                }
            })
        },
        /*===========数据校验============*/
        checkTimeValidator(rule, value, callback) {
            if (this.supplierForm.beginTime === '' || !this.supplierForm.beginTime) {
                callback(new Error('请选择开始日期'))
            } else if (this.supplierForm.endTime === '' || !this.supplierForm.endTime) {
                callback(new Error('请选择结束日期'))
            } else {
                callback()
            }
        },
        checkUpdateTimeValidator(rule, value, callback) {
            if (this.updateSupplierForm.beginTime === '' || !this.updateSupplierForm.beginTime) {
                callback(new Error('请选择开始日期'))
            } else if (this.updateSupplierForm.endTime === '' || !this.updateSupplierForm.endTime) {
                callback(new Error('请选择结束日期'))
            } else {
                callback()
            }
        },
        startDateConfirm(e) {
            if (e >= this.supplierForm.endTime) {
                this.supplierForm.endTime = '';
            }
        },
        endDateConfirm(e) {
            if (e <= this.supplierForm.beginTime) {
                this.supplierForm.beginTime = '';
            }
        },
        disabledDate(current) {
            return current && current < Number(new Date()) - 86400000
        },
        endDisabledDate(current) {
            if (this.supplierForm.beginTime) {
                return current && current < this.supplierForm.beginTime
            } else {
                return current && current < Number(new Date()) - 86400000
            }
        },
    },
}
</script>
<style scoped>
.admin-select1{
    width: 90px;
}
.admin-select1 /deep/ .el-select__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.admin-input1 /deep/ .el-input__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.name-search-btn{
    background-color: #377f7f!important;
    color: #fff!important;
}

</style>
